
import React from 'react';
import { Ship } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-ocean-800 py-10 text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-6 md:mb-0">
            <Ship className="h-8 w-8 mr-3 text-ocean-300" />
            <span className="font-poppins font-bold text-xl">Dive Shop Quote Generator</span>
          </div>
          
          <div className="text-ocean-300 text-sm">
            © {currentYear} Dive Shop Quote Generator. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
